module.exports = __webpack_public_path__ + "static/media/sleep.d0f9cde0.jpg";